import { useEffect } from "react";
import { useNavigate } from "react-router-dom";



function Error() {
    const navigate =useNavigate();
    
    useEffect(()  => {
        sessionStorage.clear();
        navigate('/')
    },[navigate])
    
    return (
        <>
        Invalid Page
        </>
      
        // <Navigate to='/' />
     
    )
  }
  
  export default Error